import React from 'react'
import { Box, styled } from '@mui/system'
import { LinearProgress } from '@mui/material'

const ICON_SIZE = 28

const StyledLoading = styled('div')(() => ({
	width: '100%',
	height: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	'& img': {
		width: 'auto',
		height: `${ICON_SIZE}px`
	},
	'& .progress': {
		position: 'relative',
		top: -4,
		margin: `0 2px`
	}
}))

const Loading = () => {
	return (
		<StyledLoading>
			<Box position='relative'>
				<img src='/assets/images/logoEnmoBlue.png' alt='' />
				<LinearProgress className='progress' />
			</Box>
		</StyledLoading>
	)
}

export default Loading
